import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const NewsCategoryList = Loadable(
  lazy(() => import("features/newsCategory/components/List"))
);
const NewsCategoryPage = Loadable(
  lazy(() => import("features/newsCategory/components/Page"))
);

const routes = {
  path: "newsCategory",
  children: [
    { path: "", element: <NewsCategoryList /> },
    { path: "add", element: <NewsCategoryPage /> },
    { path: "edit/:newsCategoryID?", element: <NewsCategoryPage /> },
  ],
};

export default routes;
